import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-531c3692"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center py-5" }

import mynaviServices from '@/services/mynavi.services'
import { useRoute, useRouter } from 'vue-router'
import { watch } from 'vue'
import axios from 'axios'
import { setHeaders } from '@/utils'
import { omit } from 'lodash'
import { PATH } from '@/constants'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

axios.defaults.headers['token-key'] = route.query?.token_key

watch(
  () => route.query?.token_key,
  async () => {
    if (route.query?.token_key)
      try {
        setHeaders({ 'request-path': PATH['community'].path })
        const data = await mynaviServices.loginMynaviApi()
        if (data.headers?.expiry) {
          const { two_fa_setting: twoFaSetting } = data.data.data
          axios.defaults.headers['X-CSRF-TOKEN'] = data.headers['access-token']

          const { expiry } = data.headers

          let expires = `${expiry ? new Date(parseInt(expiry) * 1000).toUTCString() : new Date()['toGMTString']()}`

          const basePath = PATH[`community`]
          const dataHeader = { ...data.headers, 'request-path': basePath.path }

          document.cookie = `${basePath.pathName}=${basePath.path}; expires=${expires}; path=/`

          document.cookie = `${basePath.header}=${JSON.stringify(omit(dataHeader, ['cache-control', 'content-type']))}; expires=${expires}; secure; path=/`
          document.cookie = `${basePath.path}-required-two-factor=${!twoFaSetting}; expires=${expires}; path=/`
          setHeaders(dataHeader)
          router.push({ path: twoFaSetting ? '/community/lobby' : '/community/2fa_notification' })
        } else {
          router.push({ path: '/community/users/login' })
        }
      } catch (error) {
        console.log(error)
      }
  },
  {
    immediate: true,
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", _hoisted_1, "Mynavi Login"))
}
}

})